import {Mapper} from '@s-ui/domain'

export default class FromVersionInfoRawDataToVersionInfoValueObjectMapper extends Mapper {
  constructor({
    fromImagesListRawDataToImagesListValueObjectMapper,
    fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper,
    fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper,
    versionSpecificationsValueObjectFactory,
    versionInfoValueObjectFactory
  }) {
    super()
    this._fromImagesListRawDataToImagesListValueObjectMapper = fromImagesListRawDataToImagesListValueObjectMapper
    this._fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper =
      fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper
    this._fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper =
      fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper
    this._versionSpecificationsValueObjectFactory = versionSpecificationsValueObjectFactory
    this._versionInfoValueObjectFactory = versionInfoValueObjectFactory
  }

  map = ({versionInfo, makeCode, modelCode, bodyTypeCode, path}) => {
    const {items: images} = this._fromImagesListRawDataToImagesListValueObjectMapper
      .map({images: versionInfo.images})
      .toJSON()

    const {items: marketedVersions} = this._fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper
      .map({marketedVersionsList: versionInfo.marketedList})
      .toJSON()

    const specifications = this._versionSpecificationsValueObjectFactory({
      ...versionInfo.specifications,
      doors: Number(versionInfo.specifications.doors)
    })

    const {year: currentYear, availableYears, makeId, modelId, price} = versionInfo
    const {initDate: initMarketedDate = []} = [...marketedVersions].pop()

    const {items: availableMarketedYears} = this._fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper
      .map({
        availableYears,
        currentYear,
        path
      })
      .toJSON()

    return this._versionInfoValueObjectFactory({
      versionInfo: {
        images,
        marketedVersions,
        specifications,
        year: currentYear,
        availableMarketedYears,
        makeId,
        modelId,
        price,
        initMarketedDate,
        make: makeCode,
        model: modelCode,
        bodyType: bodyTypeCode
      }
    })
  }
}
